export const FeedbackStatusEnum = {
  /**
   * 未處理
   */
  UNPROCESSED: 0,
  /**
   * 處理中
   */
  PROCESSING: 1,
  /**
   * 已完成
   */
  COMPLETED: 2,
}

export const FeedbackStatusColorEnum = {
  [FeedbackStatusEnum.UNPROCESSED]: '#FF4D4F',
  [FeedbackStatusEnum.PROCESSING]: '#FAAD14',
  [FeedbackStatusEnum.COMPLETED]: '#52C41A',
}

export const useFeedbackStatusEnumText = () => {
  const enumToText = (status: number) => {
    switch (status) {
      case FeedbackStatusEnum.UNPROCESSED:
        return '未處理'
      case FeedbackStatusEnum.PROCESSING:
        return '處理中'
      case FeedbackStatusEnum.COMPLETED:
        return '已完成'
      default:
        return 'Unknown'
    }
  }

  return {
    enumToText,
  }
}
